import { render, staticRenderFns } from "./LoginRequired.vue?vue&type=template&id=28783f00"
import script from "./LoginRequired.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginRequired.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports